(ns assemble.component.file-tree.db
  (:require [re-frame.core :as rf]))

(defn flatten-tree [tree]
  (tree-seq :children :children tree))

(defn id->item [tree]
  (->> tree (flatten-tree) (map (juxt :asset-tree/id identity)) (into {})))

(defn tree-ancestors [id id->item]
  (loop [id id, path nil]
    (if-let [{:keys [:asset-tree/parent-id] :as node} (get id->item id)]
      (recur parent-id (conj path node))
      path)))

(defn top-level-node-from-route [tree route]
  (some (fn [node]
          (when (= (:asset-tree/default-node-folder-type (:data route))
                   (:asset-tree/folder-type node))
            node))
        (:children tree)))

(rf/reg-sub :assemble.page.assets.file-tree/current-node
  :<- [:router/current-route]
  :<- [:cqrs/value :asset/list-folders]
  (fn [[route tree] _]
    (let [route-id (get-in route [:parameters :query :node])]
      (or (get (id->item tree) route-id)
          ;; Select the default top-level folder based on the route-data
          (top-level-node-from-route tree route)))))

(rf/reg-sub :assemble.page.assets.file-tree/current-node-id
  :<- [:router/current-route]
  :<- [:cqrs/value :asset/list-folders]
  (fn [[route tree] _]
    (or (get-in route [:parameters :query :node])
        ;; Select the default top-level folder based on the route-data
        (:asset-tree/id (top-level-node-from-route tree route))
        ;; TODO hardcoded until we implement tree structure for pre-made-templates
        (when (= (:asset-tree/default-node-folder-type (:data route))
                 "pre-made-templates")
          :pre-made-templates))))

(rf/reg-sub :assemble.page.assets.file-tree/font-family
  :<- [:router/current-route]
  (fn [route _]
    (get-in route [:query-params :font-family])))

(rf/reg-sub ::expanded
  (fn [db _]
    (or (get-in db [:assets-page :expanded])
        {})))

(rf/reg-sub :assemble.page.assets.file-tree/id->item
  :<- [:cqrs/value :asset/list-folders]
  (fn [tree _]
    (id->item tree)))

(rf/reg-sub :assemble.page.assets.file-tree/get-item
  :<- [:assemble.page.assets.file-tree/id->item]
  (fn [id->item [_ id]]
    (get id->item id)))

(rf/reg-sub :assemble.page.assets.file-tree/parent-nodes
  :<- [:assemble.page.assets.file-tree/current-node-id]
  :<- [:assemble.page.assets.file-tree/id->item]
  (fn [[id id->item] _]
    (tree-ancestors id id->item)))

(rf/reg-sub :assemble.page.assets.file-tree/parent-node-ids
  :<- [:assemble.page.assets.file-tree/parent-nodes]
  (fn [nodes _]
    (mapv :asset-tree/id nodes)))

(rf/reg-sub :assemble.page.assets.file-tree/child-names
  :<- [:assemble.page.assets.file-tree/current-node-id]
  :<- [:cqrs/value :asset/list-folders]
  (fn [[id folders] _]
    (loop [[i & is] (flatten-tree folders)]
      (cond (= id (:asset-tree/id i)) (->> i :children (map :asset-tree/name))
            (seq is) (recur is)))))

(rf/reg-sub ::current-node-children
  :<- [:assemble.page.assets.file-tree/current-node-id]
  :<- [:cqrs/value :asset/list-folders]
  (fn [[id tree]]
    (get-in (id->item tree) [id :children])))

(rf/reg-event-fx :assemble.page.assets.file-tree/set-current-node
  (fn [_ [_ node]]
    {:router/update-query #(-> %
                               (assoc :node node)
                               (dissoc :file))}))

(rf/reg-event-db ::add-expanded
  (fn [db [_ path]]
    (when (seq path)
      (update-in db [:assets-page :expanded] update-in path #(or % {})))))

(rf/reg-event-db ::toggle-expanded
  (fn [db [_ path]]
    (update-in db [:assets-page :expanded] update-in path (fn [v]
                                                            (if v
                                                              nil
                                                              {})))))
